

import { useRef } from "react";
import { ActionHandlerProvider } from "../Components/ActionHandlerContext";

import { FormInstance } from "antd";
import InterfaceComponent from "./Masters/InterfaceComponent";

export default function PersonalDetails() {
  const formRef = useRef<FormInstance>(null);
  const reportActionHandler = {
    checkIfValidationOK: async (actionType: string, ...params: any[]) => {
      console.log(`${actionType} action with parameters:`, params);
      // Simulate an async operation (e.g., an API call)
      await new Promise((resolve) => setTimeout(resolve, 3000)); // Simulate 1-second delay
       
      return true;
    },
    Query: async (...params: any[]) => {
      console.log(`${params[1]} 387 action with parameters:`, params);
      await new Promise((resolve) => setTimeout(resolve, 3000)); // Simulate 1-second delay
      return true;
    },
    CheckReportActionFunction: async (actionType: string, ...params: any[]) => {
      console.log(`${actionType} action with parameters:`, params);
      console.log("CheckReportActionFunction run");
      // Simulate an async operation (e.g., an API call)
      await new Promise((resolve) => setTimeout(resolve, 3000)); // Simulate 1-second delay
       
      return true;
    },
  };
  const rowActionHandler = {
    DynamicMasterRowView: async (...params: any[]) => {
      console.log(`${params[1]} action with parameters:`, params);
      console.log("rowActionHandler");
      await new Promise((resolve) => setTimeout(resolve, 3000)); // Simulate 1-second delay
      return true;
    },
    viewClick: (...params: any[]) => {
      console.log(`${params[1]} action with parameters:`, params);
      if (params[1].Title.includes("Har")) {
        return false;
      }
      return true;
    },
  };

  const interfaceActionHandler = {
    handleSubmit: async (actionType: string, ...params: any[]) => {
      console.log(`${actionType} action with parameters:`, params);
      console.log("handleSubmit run");
      // Simulate an async operation (e.g., an API call)
      await new Promise((resolve) => setTimeout(resolve, 3000)); // Simulate 1-second delay
      
    },
    handleEndFunction: async (actionType: string, ...params: any[]) => {
      console.log(`${actionType} action with parameters:`, params);
      console.log("handleEndFunction run");
      // Simulate an async operation (e.g., an API call)
      await new Promise((resolve) => setTimeout(resolve, 3000)); // Simulate 1-second delay
      
    },
    Query: async (...params: any[]) => {
      console.log(`${params[1]} 409 action with parameters:`, params);
      await new Promise((resolve) => setTimeout(resolve, 3000)); // Simulate 1-second delay
      return true;
    },
  };

  const interfaceFieldActionHandler = {
    SetStateSingleValue: async (form: any) => {
      let formData = form.getFieldsValue();
      console.log(formData);
       
    },
    HandleGenderOnChange: async (form: any) => {
      let values: Record<string, any>;

        if ('getFieldsValue' in form) {
          values = form.getFieldsValue();
        } else {
          values = form;
        }

        console.log(values);
        if(values['Gender1'] === '1')
        {
          await formRef.current!.hideField('MotherName');
        }
        else
        {
          await formRef.current!.showField('MotherName');
        }
        
    }
  };

  return (
      <ActionHandlerProvider
        rowActionHandler={rowActionHandler}
        reportActionHandler={reportActionHandler}
        interfaceActionHandler={interfaceActionHandler}
        interfaceFieldActionHandler={interfaceFieldActionHandler}
      >
       <InterfaceComponent
          InterfaceName={"Personal Details"}
          DashboardName={""}
          actionType={"DynamicFormActionUpdate"}
          RId={2}
          Mode={"Edit"}
           
          ref={formRef}
        />
        
      </ActionHandlerProvider>
  );
}
